import React, { useEffect, useState } from 'react';
import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Icon,
  useDisclosure,
  Flex,
} from '@chakra-ui/react';

import { refineUrlDomain } from '@components/Utility/utils';
import { ChevronRightIcon } from '@chakra-ui/icons';
const cardBgColor = '#F1EBDF';
import PrsProgramFinderModal from '@in-person/Components/Modal/ProgramFinderPrs';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { color } from 'framer-motion';
const cardBorderColor = '#C7C1B5';
const titleColor = '#12166F';

const ProgramModeCard = ({ onClose, mode, onSelect, onClick }) => {
  const descText = render(mode?.description);
  return (
    <Box
      bg={cardBgColor}
      borderWidth="1px"
      borderColor={cardBorderColor}
      py={4}
      px={6}
      height={'100%'}
      cursor="pointer"
      transition="all 0.2s"
      _hover={{
        borderWidth: '1px',
        borderColor: '#F37021',
      }}
      onClick={() => onSelect(mode)}
    >
      <Flex
        justify="space-between"
        align="flex-start"
        onClick={() => {
          if (mode.id === 'in-person') {
            onClick(mode);
          }
          if (mode.title === 'Online') {
            // onClick(mode);
            onClose && onClose();
            window.scrollTo({
              top: document.getElementById('ieo-enroll-section').offsetTop,
              behavior: 'smooth',
            });
          }
          if (mode.title === 'Join Sadhguru Live') {
            // window.scrollTo({
            //   top: document.getElementById('sadhguru-live').offsetTop,
            //   behavior: 'smooth',
            // });
            const url = mode?.buttonLink ?? '';
            if (url && url.trim()) {
              onClose && onClose();
              window.open(url, '_blank', 'noopener,noreferrer');
            }
          }
        }}
      >
        <Box flex="1">
          <HStack spacing={2} mb={'18px'} align="center">
            <Text
              fontWeight="500"
              color={titleColor}
              fontFamily="FedraSansStd-medium"
              fontSize="20px"
            >
              {mode.title}
            </Text>
          </HStack>

          <Text
            mb={3}
            color="gray.600"
            fontFamily="FedraSansStd-book"
            fontSize="14px"
            fontWeight={'400'}
            minWidth={{ base: 0, md: '255px' }}
          >
            {mode.sessions}
          </Text>

          <VStack align="start" spacing={1}>
            <Box
              display={'flex'}
              alignItems={'start'}
              justifyContent={'start'}
              gap={2}
              mb={{ base: '10px', md: '2px' }}
            >
              <Box>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.75 10.5V9.52372C8.87157 9.46596 8.98983 9.40238 9.10443 9.33333C10.2902 8.61881 11.0833 7.31869 11.0833 5.83333C11.0833 3.57817 9.25516 1.75 7 1.75C4.74484 1.75 2.91667 3.57817 2.91667 5.83333C2.91667 7.31869 3.70976 8.61881 4.89558 9.33333C5.01017 9.40238 5.12843 9.46596 5.25 9.52372V10.5M8.75 10.5V11.0833C8.75 12.0498 7.9665 12.8333 7 12.8333C6.0335 12.8333 5.25 12.0498 5.25 11.0833V10.5M8.75 10.5H5.25"
                    stroke="#F58220"
                    stroke-width="1.4"
                  />
                </svg>
              </Box>{' '}
              <StructuredTextParser
                fontFamily="FedraSansStd-book"
                fontWeight={'400'}
                fontSize="12px"
                color="#0000008A"
                lineHeight="short"
                mt="0"
                str={descText}
              />
            </Box>
            {mode.buttonText && (
              <Box
                as="a"
                style={{
                  color: '#CE6113',
                  marginBottom: '1rem',
                  fontFamily: 'FedraSansStd-book',
                  textDecoration: 'underline',
                  fontWeight: 400,
                  fontSize: '14px',
                }}
              >
                {mode.buttonText}
              </Box>
            )}
          </VStack>
        </Box>

        <Icon as={ChevronRightIcon} color="#F37021" mt={1} fontSize={'26px'} />
      </Flex>
    </Box>
  );
};

const ModeOFProgramModal = ({
  lang,
  region,
  pageData,
  pageName,
  prgData,
  width = '1000px',
  height = '460px',
}) => {
  const bannerData = pageData?.body[0]?.value?.find(
    item => item?.sectionId === 'banner-pop-up'
  );

  const [selectedMode, setSelectedMode] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const router = useRouter();
  useEffect(() => {
    if (router?.asPath?.indexOf('#choose-program-mode') > -1) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  }, [router?.asPath]);

  const handleModalClose = e => {
    e?.preventDefault();
    setShowPopup(false);
    const currentUrl =
      typeof window !== 'undefined' ? window.location.href : '';
    if (currentUrl.includes('#choose-program-mode')) {
      router.replace(
        currentUrl.replace('#choose-program-mode', ''),
        undefined,
        { shallow: true, scroll: false }
      );
    }
  };
  const {
    isOpen: isOpenProgramFinder,
    onOpen: onOpenProgramFinder,
    onClose: onCloseProgramFinder,
  } = useDisclosure();

  const handleModeSelect = mode => {
    setSelectedMode(mode);
  };

  return (
    <>
      <Modal
        isOpen={showPopup}
        isCentered
        blockScrollOnMount={true}
        onClose={handleModalClose}
        size="full"
      >
        <ModalOverlay bg={{ base: '#00000078', md: '#00000080' }} />
        <ModalContent
          mx={{ base: 0, md: 4 }}
          my={{ base: 0, md: 8 }}
          mt={{ base: 300, md: 0 }}
          maxW={width}
          minHeight={{ base: '520px', md: height }}
          p={{ base: 0, md: 4 }}
          borderRadius={{ base: '20px 20px 0 0', md: '0px' }}
          background="#fff"
        >
          <ModalHeader
            textAlign={{ base: 'start', md: 'center' }}
            p={0}
            px={{ base: '18px', md: '0px' }}
            mb={'13px'}
            mt={'52px'}
            fontWeight={500}
            color={titleColor}
            fontSize={{ base: '18px', md: '26px' }}
            fontFamily="FedraSansStd-medium"
          >
            {bannerData?.sectionContent[0]?.text}
          </ModalHeader>

          <ModalCloseButton
            size={{ base: 'sm', md: 'md' }}
            width={{ base: '30px', md: '24px' }}
            height={{ base: '30px', md: '24px' }}
            top={{ base: '-40px', md: '10px' }}
            right={{ base: '8px', md: '14px' }}
            bg={{ base: 'white', md: 'none' }}
            borderRadius={{ base: 'full', md: 'none' }}
          />

          <ModalBody pb={6} px={{ base: 4, md: 6 }}>
            <Box maxW="712px" mx="auto" maxH={{ base: '50%', md: 'auto' }}>
              {/* Mobile Layout - Stack all cards */}
              <VStack
                spacing={4}
                align="stretch"
                display={{ base: 'flex', md: 'none' }}
              >
                {bannerData?.sectionContent[1]?.cards.map((mode, index) => (
                  <ProgramModeCard
                    key={mode.id}
                    mode={mode}
                    onSelect={handleModeSelect}
                    onClick={onOpenProgramFinder}
                    onClose={handleModalClose}
                  />
                ))}
              </VStack>

              <Box
                spacing={4}
                display={{ base: 'none', md: 'grid' }}
                gridTemplateColumns="repeat(2, 1fr)"
                gridRowGap={'20px'}
                gridColumnGap={'14px'}
              >
                {/* {programData.modes.map((mode, index) => ( */}
                {bannerData?.sectionContent[1]?.cards.map((mode, index) => (
                  <Box
                    key={mode.title}
                    gridColumn={index === 2 ? { md: 'span 2' } : undefined}
                    maxH={{ base: '50%', md: '226px' }}
                    minH={{ base: '50%', md: '226px' }}
                    maxW={{ base: '100%', md: index === 2 ? '100%' : '349px' }}
                  >
                    <ProgramModeCard
                      mode={mode}
                      onSelect={handleModeSelect}
                      onClick={onOpenProgramFinder}
                      onClose={handleModalClose}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
      <PrsProgramFinderModal
        isOpen={isOpenProgramFinder}
        onClose={onCloseProgramFinder}
      />
    </>
  );
};

export default ModeOFProgramModal;
